import {DashboardType} from "../model/dashboard/types";
import {timeReportsDashboardConfig} from "./custom/time-reports";
import {personalDashboardConfig} from "./custom/personal";
import {tasksSummaryDashboardConfig} from "./custom/tasks-summary";
import MyTeamDashboardSetup from "./custom/my-team/setup";
import ProjectsSummaryDashboardSetup from "./custom/projects-overview/setup";

export type DashboardTemplateConfig = {
    templateId          : string,
    preview             : string,
    name                : string,
    dashboardTitle?     : string,
    description         : string,
    dashboardType       : DashboardType,
    configComponent?    : any,
    configFunction?     : any
}

const emptyConfig = () => {}
export const emptyCustomDashboardTemplate : DashboardTemplateConfig = {
    templateId      : 'empty',
    name            : 'Create from scratch',
    dashboardTitle  : 'Dashboard',
    description     : 'Create a personalized dashboard from scratch.',
    preview         : 'add-custom-dashboard-v2.svg',
    dashboardType   : DashboardType.CUSTOM,
    configFunction  : emptyConfig
}

export const dashboardTemplatesCustom : DashboardTemplateConfig[] = [



    {
        templateId  : 'personal',
        name        : 'Personal',
        description : 'The personal dashboard offers provides a convenient overview of user-related work items, facilitating quick task and project assessment.',
        preview     : 'personal-preview.svg',
        dashboardType   : DashboardType.CUSTOM,
        configFunction  : personalDashboardConfig
    },
    {
        templateId  : 'my-team',
        name        : 'My Team',
        description : 'My Team dashboard provides a rapid team performance overview, enabling you to assess tasks, progress, and priorities for each user.',
        preview     : 'my-team-preview.svg',
        dashboardType   : DashboardType.CUSTOM,
        configComponent : MyTeamDashboardSetup,
    },
    {
        templateId      : 'projects-summary',
        name            : 'Projects Summary',
        description     : 'The Project Summary Dashboard provides a detailed overview of selected projects, allowing you to track progress, milestones, and key metrics.',
        preview         : 'projects-summary-preview.svg',
        dashboardType   : DashboardType.CUSTOM,
        configComponent : ProjectsSummaryDashboardSetup

    },
    {
        templateId  : 'tasks-summary',
        name        : 'Tasks Summary',
        description : 'Summary report on all open tasks across active projects within your organization.',
        preview     : 'task-summary-preview.svg',
        dashboardType   : DashboardType.CUSTOM,
        configFunction  : tasksSummaryDashboardConfig

    },
    {
        templateId  : 'time-reporting',
        name        : 'Time Reporting',
        description : 'The Time Reporting Dashboard provides a summary and insights on time reports for effective analysis and productivity monitoring.',
        preview     : 'time-reporting-preview.svg',
        dashboardType   : DashboardType.CUSTOM,
        configFunction  : timeReportsDashboardConfig
    },
    emptyCustomDashboardTemplate


]

